import ButtonLink from '@/common/components/ButtonLink'
import { RewardLedgerEntryData } from '@/features/tmaisUsers/types/rewardLedgerEntries.type'
import { CircleIcon } from 'lucide-react'
import { CardInfoCell } from './CardInfoCell'
import { CardWrapper } from './CardWrapper'

interface CompletedMissionCardProps {
  entry: RewardLedgerEntryData
}

export const CompletedMissionCard = ({ entry }: CompletedMissionCardProps) => {
  const mission = entry.from && 'display_name' in entry.from && 'id' in entry.from ? entry.from : null

  return (
    <CardWrapper entry={entry}>
      <div className="grid grid-cols-1 gap-2">
        <CardInfoCell label="Missão">
          <ButtonLink
            linkTo={`/tmais-missions/${mission?.id ?? ''}`}
            operationKlassToCheckPermission="Admin::Tmais::Missions::Show"
            hoverBackgroundSize="small"
          >
            <CircleIcon className="size-4 fill-slate-200 shrink-0" />

            <span className="text-sm truncate">{mission?.display_name ?? '--'}</span>
          </ButtonLink>
        </CardInfoCell>
      </div>
    </CardWrapper>
  )
}
